// extracted by mini-css-extract-plugin
export default {"pendingStatusCard":"style_pendingStatusCard__kaqfh","text":"style_text__v-cEa","cardIcon":"style_cardIcon__XY4ha"};